import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalBasic() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Basic: Bridging the Connectivity Gap for Remote Areas and
          Enterprises
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Reliable 4G/5G and Fixed Wireless Access (FWA) solutions for
          enterprises where public networks fall short.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">FlexNet Basic</span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Empower businesses with FlexNet Basic. Our 4G/5G private networks
              and FlexWave (FWA) solutions ensure robust, fiber-independent
              connectivity in remote regions and enterprise sites.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://rockwellautomation.scene7.com/is/image/rockwellautomation/16x9-woman-laptop-digital-factory-blue-illustration-SHS-763228831.2400.jpg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet for Basic?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Basic </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Technical Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  4G/5G connectivity with advanced QoS features
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Support for Sub-6 and mmWave FWA (FlexWave)
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Satellite backhaul and mesh networking capabilities
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Secure, encrypted communication protocols
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Easy integration with existing IT infrastructure
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Connect the Unconnected?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Reliable 4G/5G Connectivity for Remote and Rural Areas",
    detail:
      "Ensure seamless network access even in the most challenging locations.",
    icon: "pi pi-globe",
  },
  {
    title:
      "Enterprise-Grade Connectivity Where Public Networks Are Weak or Absent",
    detail: "Provide stable and high-speed internet for business operations.",
    icon: "pi pi-wifi",
  },
  {
    title:
      "Fixed Wireless Access (FWA) via Sub-6 or mmWave (FlexWave) to Avoid Fiber Dependency",
    detail:
      "Enable high-speed broadband without the need for fiber infrastructure.",
    icon: "pi pi-wifi",
  },
  {
    title: "Satellite Backhaul and Mesh Networking for Maximum Coverage",
    detail: "Expand connectivity with hybrid networking solutions.",
    icon: "pi pi-cloud",
  },
  {
    title: "Fast Deployment and Scalable Network Infrastructure",
    detail: "Quickly set up and scale networks as needed.",
    icon: "pi pi-cog",
  },
];

const useCases = [
  {
    title: " 1: Enterprise Connectivity in Remote Industrial Sites",
    description:
      "Provide robust 4G/5G connectivity for enterprises operating in remote locations (e.g., rural zones, oil rigs, mines, construction sites) where public networks or fiber infrastructure are unavailable.",
    benefits: [
      {
        title: "Ensure uninterrupted business operations",
        icon: "pi pi-briefcase",
      },
      {
        title: "Connect IoT devices for real-time monitoring",
        icon: "pi pi-cloud",
      },
      {
        title: "Improve worker safety with reliable communication channels",
        icon: "pi pi-shield",
      },
    ],
    devices: [
      { title: "FlexNet or FlexWave 4G/5G", icon: "pi pi-wifi" },
      { title: "Enterprise Routers", icon: "pi pi-server" },
      { title: "IoT Gateways", icon: "pi pi-cloud" },
    ],
    applications: [
      { title: "Remote Site Management", icon: "pi pi-desktop" },
      { title: "Industrial IoT", icon: "pi pi-cog" },
      { title: "Worker Safety Platforms", icon: "pi pi-users" },
    ],
  },
  {
    title: " 2: Fixed Wireless Access (FWA) for Businesses",
    description:
      "Deploy FlexWave solutions using Sub-6 or mmWave spectrum to deliver high-speed broadband services, eliminating the need for fiber infrastructure.",
    benefits: [
      {
        title: "Fiber-like speeds without costly fiber installations",
        icon: "pi pi-chart-line",
      },
      {
        title: "Flexible deployment for urban, suburban, and rural areas",
        icon: "pi pi-arrows-h",
      },
      {
        title: "Scalable connectivity for growing business needs",
        icon: "pi pi-table",
      },
    ],
    devices: [
      { title: "FlexWave CPEs", icon: "pi pi-wifi" },
      { title: "mmWave Base Station", icon: "pi pi-wifi" },
    ],
    applications: [
      { title: "Business Internet", icon: "pi pi-globe" },
      { title: "Cloud Applications", icon: "pi pi-cloud" },
      { title: "VoIP Services", icon: "pi pi-phone" },
    ],
  },
  {
    title:
      " 3: Private Communication Networks for Enterprises in Isolated Locations",
    description:
      "Replace outdated DECT systems in enterprises located in remote or border areas with modern 4G/5G private networks to support both voice and data communications.",
    benefits: [
      {
        title: "Enhanced mobility and flexibility compared to traditional DECT",
        icon: "pi pi-arrows-h",
      },
      {
        title: "Support for critical communication applications",
        icon: "pi pi-comments",
      },
      {
        title: "Secure, encrypted voice and data channels",
        icon: "pi pi-lock",
      },
    ],
    devices: [
      { title: "4G/5G Small Cells", icon: "pi pi-wifi" },
      { title: "VoIP Gateways", icon: "pi pi-server" },
      { title: "Enterprise Handsets", icon: "pi pi-mobile" },
    ],
    applications: [
      { title: "Secure Voice Communication", icon: "pi pi-phone" },
      { title: "Push-to-Talk", icon: "pi pi-comments" },
      { title: "Enterprise Messaging", icon: "pi pi-envelope" },
    ],
  },
  {
    title: " 4: Cross-Border Connectivity for Government and Security Agencies",
    description:
      "Establish secure, reliable communication networks for government entities and security forces operating in border areas where public networks are unavailable.",
    benefits: [
      {
        title: "Reliable and secure communication in critical regions",
        icon: "pi pi-globe",
      },
      {
        title: "Real-time data transfer for surveillance and monitoring",
        icon: "pi pi-eye",
      },
      {
        title: "Fast deployment for temporary or mobile operations",
        icon: "pi pi-clock",
      },
    ],
    devices: [
      { title: "FlexNet Portable 4G/5G", icon: "pi pi-wifi" },
      { title: "Satellite Backhaul", icon: "pi pi-globe" },
      { title: "Secure Routers", icon: "pi pi-server" },
    ],
    applications: [
      { title: "Border Patrol Operations", icon: "pi pi-shield" },
      { title: "Military Communication", icon: "pi pi-sitemap" },
      {
        title: "Disaster Response Networks",
        icon: "pi pi-exclamation-triangle",
      },
    ],
  },
];
